import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { Accordion, Icon, Segment } from "semantic-ui-react";
import BreadcrumbContainer from "../../../app/common/breadcrumb/BreadcrumbContainer";
import { sectionReport } from "../../../app/util/breadcrumbOptions";
import ListSettlementReport from "./ListSettlementReport";
import SettlementFilter from "./SettlementFilter";
import SettlementFilterInfo from "./SettlementFilterInfo";

const DashboardSettlementReport: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    acordionSettlementFilter,
    changeStateAcordionSettlement,
  } = rootStore.reportStore;

  document.title = "Liquidación consumo mensual";
  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title="Liquidación consumo mensual"
        sections={sectionReport}
      />
      <Segment className="accordionSegment">
        <Accordion>
          <Accordion.Title
            active={acordionSettlementFilter}
            onClick={() => changeStateAcordionSettlement()}
          >
            <Icon name="dropdown" />
            {acordionSettlementFilter ? "Ocultar filtros" : "Ver filtros"}
          </Accordion.Title>
          <Accordion.Content active={acordionSettlementFilter}>
            <SettlementFilter />
          </Accordion.Content>
          <Accordion.Content active={!acordionSettlementFilter}>
            <SettlementFilterInfo />
          </Accordion.Content>
        </Accordion>

        <ListSettlementReport />
        <br />
      </Segment>
    </div>
  );
};

export default observer(DashboardSettlementReport);
